export const environment = {
  production: true,
  apiURL: 'https://api.appack.de',
  staticParams: {}
};
